import httpService from '@/api/httpService'

const AuthApi = (() => {
  const apiPostfix = 'authorization'

  return {
    apiPostfix: apiPostfix,

    async login (payload) {
      const response = await httpService.post(
        `${apiPostfix}/login`,
        payload
      )
      return response.data
    },

    async register (payload) {
      const response = await httpService.post(
        `${apiPostfix}/register`,
        payload
      )
      return response.data
    }
  }
})()

export default AuthApi
